import api from './api';

export interface InternalTaskType {
  id: number;
  name: string;
  default_assignee_ids: number[] | null;
  assign_type: string | null;
  show_meeting_dropdown: boolean;
  default_action: string | null;
  sort_order: number;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface InternalTaskTypeCreate {
  name: string;
  default_assignee_ids?: number[] | null;
  assign_type?: string | null;
  show_meeting_dropdown?: boolean;
  default_action?: string | null;
  sort_order?: number;
}

export type InternalTaskTypeUpdate = Partial<InternalTaskTypeCreate>;

export const internalTaskTypeService = {
  async getAll(tenantId?: number): Promise<InternalTaskType[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/internal-task-types/${params}`);
    return response.data;
  },

  async create(tenantId: number, data: InternalTaskTypeCreate): Promise<InternalTaskType> {
    const response = await api.post(`/internal-task-types/?tenant_id=${tenantId}`, data);
    return response.data;
  },

  async update(id: number, data: InternalTaskTypeUpdate): Promise<InternalTaskType> {
    const response = await api.put(`/internal-task-types/${id}`, data);
    return response.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/internal-task-types/${id}`);
  },
};

export default internalTaskTypeService;
